<template>
  <div>
    <admin-table :field_list="tableData"
                        :items="tableItems"
                        :filtered="filtered"
                        :allCount="allCount"
                        :filteredCount="filteredCount"
                        nextPageName="nopage"
                        :table_width="800"
                        @ordering="ordering"
                        @selPageLength="selPageLength">
      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </div>

      <div slot="name" slot-scope="props">
        <span v-if="props.item.product.option">{{ props.item.product.option.name }}</span>
      </div>

      <div slot="created_time" slot-scope="props">
        {{convertDate(props.item.created_time, 'datetime')}}
      </div>

      <!-- 총 상품 금액-->
      <div slot="all_price" slot-scope="props">
        {{ props.item.all_price | currency }}
      </div>

      <!-- 주문 상태 -->
      <div slot="status" slot-scope="props">
        {{ orderStatus(props.item.status) }}
      </div>

      <!-- 결제 상태 -->
      <div slot="pay_status" slot-scope="props">
        {{ payStatus(props.item.status )}}
      </div>

      <div slot="spot">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e => status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item,idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px" @click="clickChange">일괄처리</button>
          <!--<button class="button" style="margin-left:8px" @click="cancelPurchase">취소처리</button>-->
        </div>
      </div>
    </admin-table>

    <div style="border: 1px solid red;">
      <div class="debug-login"
        v-if="!user.token">
        <span>EMAIL</span><input v-model="user.email">
        <span>PASSWORD</span><input v-model="user.password">
        <button @click="debugUserLogin">LOGIN</button>
      </div>
      <div class="debug-detail"
        v-if="user.purchaseDetail">
        <div>Downloads</div>
        <div
          v-for="download in user.purchaseDetail.detail.downloads" :key="download.id"
          style="border: 1px dotted black;">
          <div>
            <span>id: </span><span>{{ download.id }}</span>
          </div>
          <div>
            <span>download count: </span>
            <span>{{ `${download.download_count} / ${download.download_count_max}` }}</span>
          </div>
          <div>
            <span>filename: </span>
            <span>{{ download.filename }}</span>
          </div>
          <div class="debug-detail-product-download"
            v-if="debugFindLink(download.id)">
            <a :href="'/api' + debugFindLink(download.id).downloadLink"
              style="color: blue;">download</a>
          </div>
          <button
            v-if="!debugFindLink(download.id)"
            @click="debugGetProductDownloadDetail(download.id)">GET LINK</button>
        </div>
      </div>
    </div>

    <modal name="cancelModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="삭제" :useTab="false" class="lp-modal-wrapper">
        <div>결제취소 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelModal')">취소</button>
          <button class="button is-primary" @click="confirmModal(900)">확인</button>
        </div>
      </admin-box-item>
    </modal>
  </div>
</template>

<script>
  import AdminTable from "../../../../module/admin/AdminTable";
  import LpCheckBool from "../../../../module/common/LpCheckBool";
  import Const from "../../../../../utils/const"
  import ListMixin from "@/mixins/ListMixin"

  export default {
    components: {LpCheckBool, AdminTable},
    mixins: [
      ListMixin
    ],
    data() {
      return {
        // For debugging.
        user: {
          email: 'testuser@gmail.com',
          password: '',
          id: null,
          token: null,
          purchaseDetail: null,
        },
        links: [],
      };
    },

    created() {
      this.initializing('purchase_detail', `commerce/purchase/${this.$route.query.id}/purchaseproduct`, 'PurchaseDetail');
    },
    methods: {
      // const.js 에 저장된 타입값을 가져옴
      convertType(property, status){
        return Const[property][status]
      },

      debugUserLogin() {
        this.$axios.post('auth/user/login', {
          username: this.user.email,
          password: this.user.password,
        })
          .then(res => {
            this.user.id = res.data.user.user_id;
            this.user.token = res.data.user.token;

            this.$axios.get(`user/${this.user.id}/commerce/purchase/${this.$route.query.id}`, {
              headers: {
                Authorization: `Token ${this.user.token}`,
              }
            })
              .then(res => {
                this.user.purchaseDetail = res.data.data[0];
              });
          });
      },

      debugGetProductDownloadDetail(productDownloadId) {
        this.$axios.get(`user/${this.user.id}/commerce/purchase/${this.$route.query.id}/product-download/${productDownloadId}`, {
          headers: {
            Authorization: `Token ${this.user.token}`,
          },
        })
          .then(res => {
            this.links.push({
              productDownloadId: productDownloadId,
              downloadLink: res.data.download_link,
            })
          });
      },

      debugFindLink(id) {
        return this.links.find(item => item.productDownloadId === id);
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
